<script setup>
import { computed } from 'vue';

const props = defineProps({
    title: {
        type: String,
        default: 'Section'
    },
    modelValue: {
        type: Boolean,
        default: true
    }
});

const emit = defineEmits(['update:modelValue']);

const showingContent = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value)
});
</script>

<template>
    <div class="title-container">
        <span class="section-label">{{ $t(title) }}</span>
        <v-btn
            class="toggle-button"
            @click="showingContent = !showingContent"
            variant="text"
            :prepend-icon="
                showingContent ? 'mdi-chevron-up' : 'mdi-chevron-down'
            "
        >
            <template v-slot:prepend>
                <v-icon color="primary" size="large"></v-icon>
            </template>
        </v-btn>
    </div>
</template>

<style lang="scss" scoped>
.title-container {
    position: relative;
    padding-bottom: 8px;
    border-bottom: 1px solid rgba(var(--v-theme-on-surface), 0.12);
    margin: 3px 0 16px;
}

.section-label {
    font-size: 1rem;
    font-weight: 600;
    color: rgba(var(--v-theme-on-surface), 0.87);
    line-height: 24px;
}

.toggle-button {
    position: absolute;
    top: -8px;
    right: 0;
}

:deep(.v-btn__prepend) {
    margin: 0 !important;
}
</style>
